const { CUSTOM_GTM_ID, CUSTOM_SECOND_GTM_ID, CUSTOM_SERVER_GTM_ID } = process.env;

const SERVER_GTM_ID = CUSTOM_SERVER_GTM_ID ?? 'G-GL0MWXZRS2'; // кастомный id серверного gtm или id проекта Альфабанка

const GTM_ID_CONFIG = {
    'alfabank.ru': CUSTOM_GTM_ID, // кастомный id или id проекта Альфабанка,
    'alfabank.com': CUSTOM_SECOND_GTM_ID ?? 'GTM-WVFQWGZB' // кастомный второй id или второй id проекта Альфабанка на альтернативном домене (alfabank.com)
};

const getGTMId = host => GTM_ID_CONFIG[host] ?? GTM_ID_CONFIG['alfabank.ru'];

const gtm = gtmId => `<script>
	(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
	new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
	j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
	'//www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
	})(window,document,'script','dataLayer','${gtmId}');
</script>`;

module.exports = {
    gtm,
    getGTMId
};
